import { useState } from "react";
import { ActionButton } from "@wine2trace/ui/FormComponents";
import useLabels from "../../hooks/useLabels";
import NotesModal from "./NotesModal";

import "./styles/index.scss";

// Floating button, on every page, that opens the user's sticky note.
const NotesButton = () => {
  const [getLabel] = useLabels();
  const [isNotesOpen, setIsNotesOpen] = useState(false);

  return (
    <div className="notes_wrapper">
      <ActionButton
        variant="icon"
        icon="fa-note-sticky"
        className="notes_button"
        label={getLabel("stickyNoteOpen")}
        title={getLabel("stickyNoteOpen")}
        onClick={() => setIsNotesOpen(true)}
      />
      <NotesModal onClose={() => setIsNotesOpen(false)} isOpen={isNotesOpen} />
    </div>
  );
};

export default NotesButton;
